import { Component, OnInit } from "@angular/core";
import { ComponentBase } from "../../models/ComponentBase";
import { ProjectCo2Service } from "../../services/projectco2.service";

@Component({
    selector: "app-display-sustainability-disclaimer",
    template: ` <div class="disclaimer" *ngIf="disclaimerText">
        <strong>Disclaimer</strong>: {{disclaimerText}}
    </div>`,
    styles: [
        `
            .disclaimer {
                text-align: center;
                margin: 20px 20px 0 20px;
                border: 1px solid #1091d1;
                padding: 5px 10px;
                border-radius: 5px;
                background-color: #fafafa;
                max-width: 800px;
                margin-left: auto;
                margin-right: auto;
            }
        `,
    ],
    standalone: false,
})
export class DisplaySustainabilityDisclaimerComponent
    extends ComponentBase
    implements OnInit
{
    public disclaimerText: string | undefined = undefined;

    constructor(private readonly projectCo2Service: ProjectCo2Service) {
        super();
    }

    ngOnInit(): void {
        let projectCo2ConsumptionSubscription = this.projectCo2Service
            .getProjectCo2()
            .subscribe((c) => (this.disclaimerText = c?.disclaimer));

        this.subscriptions.push(projectCo2ConsumptionSubscription);
    }
}
